exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".prize-panel[data-v-ea214fca] {\n  width: 100%;\n  height: 100%;\n  background: no-repeat center / cover;\n}\n", ""]);
